import { render, staticRenderFns } from "./get-exchange-tracking-number.vue?vue&type=template&id=6c00e03a&scoped=true"
import script from "./get-exchange-tracking-number.vue?vue&type=script&lang=tsx"
export * from "./get-exchange-tracking-number.vue?vue&type=script&lang=tsx"
import style0 from "./get-exchange-tracking-number.vue?vue&type=style&index=0&id=6c00e03a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c00e03a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c00e03a')) {
      api.createRecord('6c00e03a', component.options)
    } else {
      api.reload('6c00e03a', component.options)
    }
    module.hot.accept("./get-exchange-tracking-number.vue?vue&type=template&id=6c00e03a&scoped=true", function () {
      api.rerender('6c00e03a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ops/get-exchange-tracking-number.vue"
export default component.exports